import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useCallback, useMemo } from 'react';

const cn = {
  泰国任务: '泰国任务',
  巴西任务: '巴西任务',
  智利任务: '智利任务',
  哥伦比亚任务: '哥伦比亚任务',
  西班牙任务: '西班牙任务',
  法国任务: '法国任务',
  印尼任务: '印尼任务',
  墨西哥任务: '墨西哥任务',
  马来西亚任务: '马来西亚任务',
  菲律宾任务: '菲律宾任务',
  波兰任务: '波兰任务',
  新加坡任务: '新加坡任务',
  台湾任务: '台湾任务',
  越南任务: '越南任务',
  默认任务: '默认任务',

  通用策略: '通用策略',
  大促预热: '大促预热',
  大促期间: '大促期间',
  大促返场: '大促返场',
  日常发货类: '日常发货类',
  日常类: '日常类',
  品牌有保障: '品牌有保障',
  了解未下单原因: '了解未下单原因',
  大促倒计时: '大促倒计时',
  大促当天: '大促当天',
  爆款商品吸引付款: '爆款商品吸引付款',
  营造库存紧缺感: '营造库存紧缺感',
  发优惠券引导付款: '发优惠券引导付款',
  售后有保障: '售后有保障',
  主动关怀: '主动关怀',
  商品类型1的使用注意事项: '商品类型1的使用注意事项',
  商品类型2的使用注意事项: '商品类型2的使用注意事项',
  签收后推荐关联商品: '签收后推荐关联商品',
  签收后主动关怀: '签收后主动关怀',
  未在卖家中心点击出货时的挽回策略: '未在卖家中心点击出货时的挽回策略',
  已在卖家中心点击出货时的挽回策略: '已在卖家中心点击出货时的挽回策略',
  周末不上班: '周末不上班',
  每日固定休息时间: '每日固定休息时间',
  邀请售前买家关注店铺: '邀请售前买家关注店铺',
  邀请售中买家关注店铺: '邀请售中买家关注店铺',
  邀请售后买家关注店铺: '邀请售后买家关注店铺',
  发送收货地址提醒买家核对: '发送收货地址提醒买家核对',
  发送收货地址提示买家已发货: '发送收货地址提示买家已发货',
  发送物流信息提醒签收: '发送物流信息提醒签收',
  发送物流信息提醒再次派送: '发送物流信息提醒再次派送',
  预热期: '预热期',
  生效期: '生效期',
};

const en = {
  泰国任务: 'Thailand',
  巴西任务: 'Brazil',
  智利任务: 'Chile',
  哥伦比亚任务: 'Columbia',
  西班牙任务: 'Spain',
  法国任务: 'France',
  印尼任务: 'Indonesia',
  墨西哥任务: 'Mexico',
  马来西亚任务: 'Malaysia',
  菲律宾任务: 'Philippines',
  波兰任务: 'Poland',
  新加坡任务: 'Singapore',
  台湾任务: 'Taiwan China',
  越南任务: 'Vietnam',
  默认任务: 'Default Task',

  通用策略: 'Common',
  大促预热: 'Promo Warm-up',
  大促期间: 'Promo On-going',
  大促返场: 'Promo Returning',
  日常发货类: 'Daily Shipment',
  日常类: 'General',
  品牌有保障: 'Brand Guaranteed',
  了解未下单原因: 'Find out the reason for not placing orders',
  大促倒计时: 'Promo Countdown',
  大促当天: 'Promo Day',
  爆款商品吸引付款: 'Hot-sellers attract buyers to pay',
  营造库存紧缺感: 'Create a situation of inventory shortage',
  发优惠券引导付款: 'Send vouchers to guide payment',
  售后有保障: 'After-Sales Services Guaranteed',
  主动关怀: 'Proactive care',
  商品类型1的使用注意事项: 'Guide for product type 1',
  商品类型2的使用注意事项: 'Guide for product type 2',
  签收后推荐关联商品: 'Recommend related products after delivered',
  签收后主动关怀: 'Proactive care after delivered',
  未在卖家中心点击出货时的挽回策略: 'Order Status=To Process',
  已在卖家中心点击出货时的挽回策略: 'Order Status=Processed',
  周末不上班: 'Weekend off',
  每日固定休息时间: 'Daily rest time',
  邀请售前买家关注店铺: 'Invite pre-sales customers to follow the store',
  邀请售中买家关注店铺: 'Invite in-sales customers to follow the store',
  邀请售后买家关注店铺: 'Invite after-sales customers to follow the store',
  发送收货地址提醒买家核对: 'Sending address to remind for check',
  发送收货地址提示买家已发货: 'Sending address to notify that order is shipped',
  发送物流信息提醒签收: 'Sending logistics info to remind for receipt',
  发送物流信息提醒再次派送: 'Sending logistics info to remind for redelivery',
  预热期: 'Pre-promo period',
  生效期: 'Validity period',
};

const id = {
  泰国任务: 'Thailand',
  巴西任务: 'Brazil',
  智利任务: 'Chile',
  哥伦比亚任务: 'Columbia',
  西班牙任务: 'Spain',
  法国任务: 'France',
  印尼任务: 'Indonesia',
  墨西哥任务: 'Mexico',
  马来西亚任务: 'Malaysia',
  菲律宾任务: 'Philippines',
  波兰任务: 'Poland',
  新加坡任务: 'Singapore',
  台湾任务: 'Taiwan China',
  越南任务: 'Vietnam',
  默认任务: 'Tugas default',

  通用策略: 'Umum',
  大促预热: 'Sebelum promo',
  大促期间: 'Hari H promo',
  大促返场: 'Setelah Hari H Promo',
  日常发货类: 'Percepat pengiriman',
  日常类: 'Regular',
  品牌有保障: 'Brand terjamin',
  了解未下单原因: 'Ketahui alasan belum checkout',
  大促倒计时: 'Countdown berakhirnya promo',
  大促当天: 'Hari H promo',
  爆款商品吸引付款: 'Produk terlaris untuk menarik minat pembayaran',
  营造库存紧缺感: 'Stok terbatas',
  发优惠券引导付款: 'Pengingat pembayaran kedua pada saat promo besar',
  售后有保障: 'Jaminan layanan after-sales',
  主动关怀: 'Berikan rasa peduli',
  商品类型1的使用注意事项: 'Hal yang harus diperhatikan saat penggunaan produk tipe 1',
  商品类型2的使用注意事项: 'Hal yang harus diperhatikan saat penggunaan produk tipe 2',
  签收后推荐关联商品: 'Setelah produk diterima, berikan rekomendasi produk terkait',
  签收后主动关怀: 'Setelah produk diterima, inisiatif berikan rasa peduli',
  未在卖家中心点击出货时的挽回策略: 'Strategi untuk status pesanan perlu dikirim',
  已在卖家中心点击出货时的挽回策略: 'Strategi untuk status pesanan dikirim',
  周末不上班: 'Akhir pekan libur',
  每日固定休息时间: 'Waktu istirahat harian',
  邀请售前买家关注店铺: 'Undang customer pre-sales untuk ikuti toko',
  邀请售中买家关注店铺: 'Undang customer in-sales untuk ikuti toko',
  邀请售后买家关注店铺: 'Undang customer after-sales untuk ikuti toko',
  发送收货地址提醒买家核对: 'Kirim alamat, ingatkan customer untuk periksa',
  发送收货地址提示买家已发货: 'Kirim alamat, ingatkan produk telah dikirim',
  发送物流信息提醒签收: 'Kirim info logistik, ingatkan untuk menerima paket',
  发送物流信息提醒再次派送: 'Kirim info logistik, ingatkan akan diantar ulang',
  预热期: 'Waktu Pre-event',
  生效期: 'Waktu Berlaku',
};

const th = {
  泰国任务: 'Thailand',
  巴西任务: 'Brazil',
  智利任务: 'Chile',
  哥伦比亚任务: 'Columbia',
  西班牙任务: 'Spain',
  法国任务: 'France',
  印尼任务: 'Indonesia',
  墨西哥任务: 'Mexico',
  马来西亚任务: 'Malaysia',
  菲律宾任务: 'Philippines',
  波兰任务: 'Poland',
  新加坡任务: 'Singapore',
  台湾任务: 'Taiwan China',
  越南任务: 'Vietnam',
  默认任务: 'ภารกิจเริ่มต้น',

  通用策略: 'กลยุทธ์ที่ใช้ได้ทั่วไป',
  大促预热: 'โปรโมชั่นใหญ่อุ่นเครื่อง',
  大促期间: 'ในช่วงเวลาโปรโมชั่นใหญ่',
  大促返场: 'โปรโมชั่นครั้งใหญ่การกลับมา',
  日常发货类: 'หมวดหมู่การจัดส่งรายวัน',
  日常类: 'ประเภทประจำวัน',
  品牌有保障: 'กำไรน้อยแต่ยอดขายมาก',
  了解未下单原因: 'ทำความเข้าใจถึงสาเหตุที่ไม่ได้สั่งซื้อ',
  大促倒计时: 'นับเวลาถอยหลังโปรโมชั่นใหญ่',
  大促当天: 'โปรโมชั่นใหญ่ในวันเดียวกัน',
  爆款商品吸引付款: 'สินค้าที่ขายดีจะดึงดูดการชำระเงิน',
  营造库存紧缺感: 'หมวดหมู่สินค้าคงคลังไม่เพียงพอ',
  发优惠券引导付款: 'แจกคูปองเพื่อนำไปสู่การชำระเงิน',
  售后有保障: 'รับประกันหลังการขาย',
  主动关怀: 'เอาใจใส่กับลูกค้าด้วยความสมัครใจ',
  商品类型1的使用注意事项: 'ข้อควรระวังในการใช้สินค้าประเภท 1',
  商品类型2的使用注意事项: 'ข้อควรระวังในการใช้สินค้าประเภท 2',
  签收后推荐关联商品: 'แนะนำผลิตภัณฑ์ที่เกี่ยวข้องหลังจากเซ็นต์รับ',
  签收后主动关怀: 'การดูแลเชิงรุกหลังการเซ็นต์รับ',
  未在卖家中心点击出货时的挽回策略: 'รอจัดส่ง',
  已在卖家中心点击出货时的挽回策略: 'ดำเนินการแล้ว',
  周末不上班: 'ไม่ทํางานในวันเสาร์-อาทิตย์',
  每日固定休息时间: 'เวลาพักผ่อนประจําทุกวัน',
  邀请售前买家关注店铺: 'เชิญชวนลูกค้าก่อนขายติดตามร้านค่ะ',
  邀请售中买家关注店铺: 'เชิญชวนลูกค้าที่กำลังขายติดตามร้านค่ะ',
  邀请售后买家关注店铺: 'เชิญชวนลูกค้าหลังการขายติดตามร้านค่ะ',
  发送收货地址提醒买家核对: 'ส่งที่อยู่รับสินค้าแจ้งเตือนผู้ซื้อให้ตรวจสอบ',
  发送收货地址提示买家已发货: 'ส่งที่อยู่รับสินค้าแจ้งผู้ซื้อว่าได้จัดส่งแล้ว',
  发送物流信息提醒签收: 'ส่งข้อมูลการขนส่งเพื่อแจ้งเตือนการเซ็นรับ',
  发送物流信息提醒再次派送: 'ส่งข้อมูลการขนส่งเพื่อแจ้งเตือนการจัดส่งอีกครั้ง',
  预热期: 'ช่วงเวลาโปรโมทก่อนแคมเปญเริ่ม',
  生效期: 'ระยะเวลาของแคมเปญ',
};

const tl = {
  泰国任务: 'Thailand',
  巴西任务: 'Brazil',
  智利任务: 'Chile',
  哥伦比亚任务: 'Columbia',
  西班牙任务: 'Spain',
  法国任务: 'France',
  印尼任务: 'Indonesia',
  墨西哥任务: 'Mexico',
  马来西亚任务: 'Malaysia',
  菲律宾任务: 'Philippines',
  波兰任务: 'Poland',
  新加坡任务: 'Singapore',
  台湾任务: 'Taiwan China',
  越南任务: 'Vietnam',
  默认任务: 'Default Task',

  通用策略: 'Common',
  大促预热: 'Promo Warm-up',
  大促期间: 'Promo On-going',
  大促返场: 'Promo Returning',
  日常发货类: 'Daily Shipment',
  日常类: 'General',
  品牌有保障: 'Brand Guaranteed',
  了解未下单原因: 'Alamin ang dahilan bakit hindi nag-peplaceng mga orders',
  大促倒计时: 'Promo Countdown',
  大促当天: 'Promo Day',
  爆款商品吸引付款: 'Hot-sellers attract buyers to pay',
  营造库存紧缺感: 'Gumawa ng situation ng inventory shortage',
  发优惠券引导付款: 'I-send ang mga vouchers para ma-guide sa payment',
  售后有保障: 'After-Sales Services Guaranteed',
  主动关怀: 'Maagap na pag-aalalay',
  商品类型1的使用注意事项: 'Guide para sa product type 1',
  商品类型2的使用注意事项: 'Guide para sa product type 2',
  签收后推荐关联商品: 'Mag-recommend ng mga related products pagkatapos madeliver',
  签收后主动关怀: 'Maagap na pag-aalalay pagkatapos ng delivery',
  未在卖家中心点击出货时的挽回策略: 'Order Status=To Process',
  已在卖家中心点击出货时的挽回策略: 'Order Status=Processed',
  周末不上班: 'Walang pasok ng weekends.',
  每日固定休息时间: 'Oras ng pahinga araw-araw',
  邀请售前买家关注店铺: 'Imbitahan ang mga pre-sales customers na i-follow ang store',
  邀请售中买家关注店铺: 'Imbitahan ang mga in-sales customers na i-follow ang store',
  邀请售后买家关注店铺: 'Imbitahan ang mga after-sales customers na i-follow ang store',
  发送收货地址提醒买家核对: 'Sending address para ipaalala na i-check',
  发送收货地址提示买家已发货: 'Sending address para i-notify na order shipped na',
  发送物流信息提醒签收: 'Sending logistics para ipaalala ang receipt',
  发送物流信息提醒再次派送: 'Isend ang logistics para ipaalala ang redelivery',
  预热期: 'Pre-promo period',
  生效期: 'Validity period',
};

const es = {
  泰国任务: 'Thailand',
  巴西任务: 'Brazil',
  智利任务: 'Chile',
  哥伦比亚任务: 'Columbia',
  西班牙任务: 'Spain',
  法国任务: 'France',
  印尼任务: 'Indonesia',
  墨西哥任务: 'Mexico',
  马来西亚任务: 'Malaysia',
  菲律宾任务: 'Philippines',
  波兰任务: 'Poland',
  新加坡任务: 'Singapore',
  台湾任务: 'Taiwan China',
  越南任务: 'Vietnam',
  默认任务: 'Default Task',

  通用策略: 'Common',
  大促预热: 'Promo Warm-up',
  大促期间: 'Promo On-going',
  大促返场: 'Promo Returning',
  日常发货类: 'Daily Shipment',
  日常类: 'General',
  品牌有保障: 'Brand Guaranteed',
  了解未下单原因: 'Find out the reason for not placing orders',
  大促倒计时: 'Promo Countdown',
  大促当天: 'Promo Day',
  爆款商品吸引付款: 'Hot-sellers attract buyers to pay',
  营造库存紧缺感: 'Create a situation of inventory shortage',
  发优惠券引导付款: 'Send vouchers to guide payment',
  售后有保障: 'After-Sales Services Guaranteed',
  主动关怀: 'Proactive care',
  商品类型1的使用注意事项: 'Guide for product type 1',
  商品类型2的使用注意事项: 'Guide for product type 2',
  签收后推荐关联商品: 'Recommend related products after delivered',
  签收后主动关怀: 'Proactive care after delivered',
  未在卖家中心点击出货时的挽回策略: 'Order Status=To Process',
  已在卖家中心点击出货时的挽回策略: 'Order Status=Processed',
  周末不上班: 'Weekend off',
  每日固定休息时间: 'Daily rest time',
  邀请售前买家关注店铺: 'Invite pre-sales customers to follow the store',
  邀请售中买家关注店铺: 'Invite in-sales customers to follow the store',
  邀请售后买家关注店铺: 'Invite after-sales customers to follow the store',
  发送收货地址提醒买家核对: 'Sending address to remind for check',
  发送收货地址提示买家已发货: 'Sending address to notify that order is shipped',
  发送物流信息提醒签收: 'Sending logistics info to remind for receipt',
  发送物流信息提醒再次派送: 'Sending logistics info to remind for redelivery',
  预热期: 'Pre-promo period',
  生效期: 'Validity period',
};

const vn = {
  泰国任务: 'Thailand',
  巴西任务: 'Brazil',
  智利任务: 'Chile',
  哥伦比亚任务: 'Columbia',
  西班牙任务: 'Spain',
  法国任务: 'France',
  印尼任务: 'Indonesia',
  墨西哥任务: 'Mexico',
  马来西亚任务: 'Malaysia',
  菲律宾任务: 'Philippines',
  波兰任务: 'Poland',
  新加坡任务: 'Singapore',
  台湾任务: 'Taiwan China',
  越南任务: 'Vietnam',
  默认任务: 'Nhiệm vụ mặc định',

  通用策略: 'Thông dụng',
  大促预热: 'Khởi động khuyến mãi',
  大促期间: 'Trong thời gian khuyến mãi',
  大促返场: 'Khuyến mãi trở lại',
  日常发货类: 'Kiểu gửi hàng thường ngày',
  日常类: 'Kiểu thường ngày',
  品牌有保障: 'Thương hiệu được đảm bảo',
  了解未下单原因: 'Tìm hiểu nguyên nhân chưa lên đơn',
  大促倒计时: 'Đếm ngược thời gian khuyến mãi',
  大促当天: 'Trong ngày khuyến mãi',
  爆款商品吸引付款: 'Thu hút thanh toán bằng sản phẩm bán chạy',
  营造库存紧缺感: 'Số lượng không đủ',
  发优惠券引导付款: 'Gửi phiếu giảm giá thúc giục quyết toán',
  售后有保障: 'Đảm bảo hậu mãi',
  主动关怀: 'Chủ động hỏi thăm người mua',
  商品类型1的使用注意事项: 'Lưu ý khi sử dụng loại hình sản phẩm 1',
  商品类型2的使用注意事项: 'Lưu ý khi sử dụng loại hình sản phẩm 2',
  签收后推荐关联商品: 'Giới thiệu sản phẩm liên quan sau khi kí nhận',
  签收后主动关怀: 'Chủ động CSKH sau khi kí nhận',
  未在卖家中心点击出货时的挽回策略: 'Chính sách cứu vãn khi chưa click gửi hàng',
  已在卖家中心点击出货时的挽回策略: 'Chính sách cứu vãn khi đã click gửi hàng',
  周末不上班: 'Cuối tuần không làm việc',
  每日固定休息时间: 'Thời gian nghỉ ngơi hàng ngày',
  邀请售前买家关注店铺: 'Mời khách hàng trước mua theo dõi cửa hàng',
  邀请售中买家关注店铺: 'Mời khách hàng đang mua theo dõi cửa hàng',
  邀请售后买家关注店铺: 'Mời khách hàng sau mua theo dõi cửa hàng',
  发送收货地址提醒买家核对: 'Gửi địa chỉ nhận hàng nhắc người mua kiểm tra',
  发送收货地址提示买家已发货: 'Gửi địa chỉ nhận hàng nhắc người mua đã gửi hàng',
  发送物流信息提醒签收: 'Gửi thông tin vận chuyển để nhắc ký nhận',
  发送物流信息提醒再次派送: 'Gửi thông tin vận chuyển nhắc giao lại',
  预热期: 'Pre-promo period',
  生效期: 'Validity period',
};

const pt = {
  泰国任务: 'Thailand',
  巴西任务: 'Brazil',
  智利任务: 'Chile',
  哥伦比亚任务: 'Columbia',
  西班牙任务: 'Spain',
  法国任务: 'France',
  印尼任务: 'Indonesia',
  墨西哥任务: 'Mexico',
  马来西亚任务: 'Malaysia',
  菲律宾任务: 'Philippines',
  波兰任务: 'Poland',
  新加坡任务: 'Singapore',
  台湾任务: 'Taiwan China',
  越南任务: 'Vietnam',
  默认任务: 'Default Task',

  通用策略: 'Common',
  大促预热: 'Promo Warm-up',
  大促期间: 'Promo On-going',
  大促返场: 'Promo Returning',
  日常发货类: 'Daily Shipment',
  日常类: 'General',
  品牌有保障: 'Brand Guaranteed',
  了解未下单原因: 'Find out the reason for not placing orders',
  大促倒计时: 'Promo Countdown',
  大促当天: 'Promo Day',
  爆款商品吸引付款: 'Hot-sellers attract buyers to pay',
  营造库存紧缺感: 'Create a situation of inventory shortage',
  发优惠券引导付款: 'Send vouchers to guide payment',
  售后有保障: 'After-Sales Services Guaranteed',
  主动关怀: 'Proactive care',
  商品类型1的使用注意事项: 'Guide for product type 1',
  商品类型2的使用注意事项: 'Guide for product type 2',
  签收后推荐关联商品: 'Recommend related products after delivered',
  签收后主动关怀: 'Proactive care after delivered',
  未在卖家中心点击出货时的挽回策略: 'Order Status=To Process',
  已在卖家中心点击出货时的挽回策略: 'Order Status=Processed',
  周末不上班: 'Weekend off',
  每日固定休息时间: 'Daily rest time',
  邀请售前买家关注店铺: 'Convida compradores de pré-venda a seguir a loja',
  邀请售中买家关注店铺: 'Convida compradores na venda a seguir a loja',
  邀请售后买家关注店铺: 'Convida compradores de pós-venda a seguir a loja',
  发送收货地址提醒买家核对: 'Envia endereço de entrega a lembrar verificação',
  发送收货地址提示买家已发货: 'Envia endereço de entrega a lembrar pedido enviado',
  发送物流信息提醒签收: 'Enviar informação logística para recepção',
  发送物流信息提醒再次派送: 'Enviar informações logísticas para segunda entrega',
  预热期: 'Período de pré-promoção',
  生效期: 'Validity period',
};

const langMap = {
  'zh-CN': cn,
  'en-US': en,
  id,
  th,
  tl,
  es,
  vi: vn,
  pt,
};

const langNumberMap = {
  'zh-CN': '策略{{x}}',
  'en-US': 'Policy {{x}}',
  id: 'Strategi {{x}}',
  th: 'กลยุทธ์ {{x}}',
  tl: 'Policy {{x}}',
  es: 'Policy {{x}}',
  vi: 'Chiến lược {{x}}',
  pt: 'Policy {{x}}',
};

export function useGetPolicyName() {
  const lang = useSystemLanguageValue();

  const getPolicyName = useCallback(
    (name: string) => {
      return name
        .split('_')
        .map((word) => {
          const [number] = word.match(/\d+/) || [];

          if (number) {
            const template = word.replace(number, '{{x}}');

            if (Object.values(langNumberMap).some((_) => _ === template)) {
              return langNumberMap[lang].replace('{{x}}', number);
            }
          }

          let key: keyof typeof cn | undefined;

          for (const map of Object.values(langMap)) {
            key = Object.keys(map).find((key) => map[key] === word);

            if (key) {
              break;
            }
          }

          return key ? langMap[lang][key] || word : word;
        })
        .join('_');
    },
    [lang],
  );

  return {
    lang,
    getPolicyName,
  };
}

export function usePolicyName(name: string) {
  const { lang, getPolicyName } = useGetPolicyName();

  const policyName = useMemo(() => getPolicyName(name), [getPolicyName, name]);

  return {
    lang,
    policyName,
    getPolicyName,
  };
}

export function PolicyName({ name }: { name: string }) {
  const { policyName } = usePolicyName(name);

  return <>{policyName}</>;
}
